















import {
  useFindMasterType,
  useLocalFilter,
  useMapMasterTypeToOptionAlt,
} from "@/hooks";
import { Option } from "@/models/class/option.class";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectSparepartRequestStatu extends Vue {
  useLocalFilter = useLocalFilter;

  @Prop({ required: false, type: String, default: undefined })
  value!: string | undefined;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Option[] = [];
  loading = false;

  created(): void {
    this.fetchData();
  }

  emits(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
  }

  fetchData(): void {
    this.loading = true;
    useFindMasterType("SPARE_PART_REQUEST_STATUS")
      .then(res => {
        this.options = useMapMasterTypeToOptionAlt(res);
        this.options = this.options.filter(
          option => option.label != "Cancelled"
        );
        this.options = this.options.map(option => ({
          ...option,
          value: option.value.replaceAll(" ", "_").toUpperCase(),
        }));
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
